import React, { useEffect, useState } from "react";
import { Col, Row, Form, Table as ReactTable } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Select as AntSelect } from "antd";
import toast, { Toaster } from "react-hot-toast";
import { formatAmount, getRestoLogin, refreshPage, toastStyle } from "../../Helpers/Utils/Common";
import Select from "react-select";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
//components
import Table from "../../Components/TableTemplate/Table";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import ViewModal from "../../Components/Modals/ViewModal";
import EditModal from "../../Components/Modals/EditModal";
import InputError from "../../Components/InputError/InputError";

//css
import "../../cssFiles/MenuManager.css";

//api
import {
  deleteMenuManager,
  updateMenuManager,
  createMenuManager
} from "../../Helpers/apiCalls/menuManagerApi";
import { validateMenu } from "../../Helpers/Validation/Admin/MenuManager";
import { getVAT } from "../../Helpers/apiCalls/MenuApi";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import moment from "moment";

export default function MenuManager() {
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(false);
  const [option, setOption] = useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [modifierItems, setModifierItems] = useState([]);
  const today = moment(new Date()).format("yyyy-MM-DD");
  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  // VIEW
  const [showViewUserModal, setShowViewUserModal] = useState(false);
  const handleShowViewUserModal = () => setShowViewUserModal(true);
  const handleCloseViewUserModal = () => setShowViewUserModal(false);

  const [selectedRow, setSelectedRow] = useState({});
  // EDIT
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const handleShowEditUserModal = () => setShowEditUserModal(true);
  const handleCloseEditUserModal = () => setShowEditUserModal(false);

  // ADD
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const handleShowAddUserModal = () => setShowAddUserModal(true);
  const handleCloseAddUserModal = () => setShowAddUserModal(false);

  //API
  const [categories, setCategories] = useState([]);
  const [editMenuInfo, setEditMenuInfo] = useState({});
  const [addMenuInfo, setAddMenuInfo] = useState({
    name: "",
    categories: "",
    remarks: "",
    price: "",
    takeout_price: "",
    foodpanda_price: "",
    grab_price: "",
    description: "",
    modifiers: [],
    file: "",
    effective_date: today,
    is_package: "0",
    is_addon: "0",
    with_discount: "0",
    is_modifier: "0",
    with_modifier: "0",
    is_dine_in: "0",
    is_take_out: "0",
    is_delivery: "0",
    ref_no: "0",
    suspend_sale: "0",
    ref_name: "0",
    weight: "",
    is_vatable: "1",
    vat_in: "0",
    vat_ex: "0",
    vat_component: "0",
    other_charges: "0",
    qty: "",
  });
  const [packageDetails, setPackageDetails] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isError, setIsError] = useState({
    name: false,
    effective_date: false,
    categories: false,
    price: false,
    item_code: false,
    menu_location: false,
    default_printer: false,
  });

  //DROPDOWN
  function handleSelectChange(e, row) {
    let details = row.menu_details || []
    setSelectedRow(row);
    if (e.target.value === "delete-user") {
      handleShowDeleteModal();
    } else if (e.target.value === "edit-user") {
      handleShowEditUserModal();
      setPackageDetails(details)
      fetchItemDetails(row.id);
    } else if (e.target.value === "view-user") {
      handleShowViewUserModal();
      fetchItemDetails(row.id);
    } else if (e.target.value === "inventory") {
      navigate("/inventory/" + row.id);
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
        value={option}
      >
        <option selected hidden>
          Select
        </option>
        <option value="view-user" className="color-options">
          View
        </option>
        <option value="edit-user" className="color-options">
          Edit
        </option>
        <option value="delete-user" className="color-red">
          Delete
        </option>
        <option value="inventory" className="color-red">
          Inventory
        </option>
      </Form.Select>
    );
  }

  async function fetchCategories() {
    setShowLoader(true);
    const response = await UseGetRequest(
      "categories/getAll",
      {},
      getRestoLogin()
    );
    if (response.data) {
      const result = response.data.categories.map((data) => {
        return {
          label: data.name,
          value: data.id,
        };
      });
      setCategories(result);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  // getShowCategories
  async function fetchItemDetails(id) {
    setShowLoader(true);
    const response = await UseGetRequest(
      "menus/show/" + id,
      {},
      getRestoLogin()
    );
    if (response.data) {
      const result = response.data; 
      let default_categories = []
      let default_modifiers = []
      result.is_vatable = parseFloat(result.vat_component) > 0 ? "1" : "0"; // if naay vat component, then vatable siya

      if(result.menu_categories){
        default_categories = result?.menu_categories.map((val) => {
          return { label: val.name, value: val.id };
        });
      }

      if(result.menu_modifiers){
        default_modifiers = result?.menu_modifiers.map((val) => {
          return val.modifier_id;
        });
      }

      const new_remark = [];
      if (result.menu_remarks) {
        result.menu_remarks.map((val) => {
          new_remark.push({ ...val, label: val.remark, value: val.remark_id });
        });
      }
      setEditMenuInfo({ ...result, default_categories, menu_remarks: [...new_remark], menu_modifiers: [...default_modifiers] });
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  const [computedVat, setComputedVat] = useState("0");

  async function fetchVatIn() {
    const response = await getVAT(addMenuInfo);
    if (response.data) {
      setComputedVat(response.data.data);
      setAddMenuInfo((prev) => ({ ...prev, ...response.data.data }));
    }
  }

  async function fetchEditVatIn() {
    const response = await getVAT(editMenuInfo);
    if (response.data) {
      setComputedVat(response.data.data);
      setEditMenuInfo((prev) => ({ ...prev, ...response.data.data }));
    }
  }


  //FETCH API CALL searchMenuManager
  async function searchMenu(name) {
    setShowLoader(true);
    setMenuItems([]);
    const response = await UseGetRequest(
      "menus/search",
      { term: name },
      getRestoLogin()
    );
    if (response.data) {
      let categories = response.data.menus;
      categories.map((item) => {
        item.products.map((info) => {
          info.category_id = item.category_id;
          info.category_name = item.category_name;
          info.value = info.id;
          info.label = info.name;
          info.categories = [
            { label: info.category_name, value: info.category_id },
          ];
          setMenuItems((prev) => [...prev, info]);
        });
      });
    } else {
      setMenuItems([]);
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  async function searchModifiers() {
    setShowLoader(true);
    setModifierItems([]);
    const response = await UseGetRequest(
      "menus/search",
      { is_modifier: 1 },
      getRestoLogin()
    );
    if (response.data) {
      setModifierItems(response?.data?.menus)
    } else {
      setModifierItems([])
    }
    setTimeout(() => setShowLoader(false), 1000);
  }

  //ADD or CREATE USER
  const handleAddOnChange = (e, type) => {
    const { name, value } = e.target;
    setAddMenuInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleAddChange = (e, type, modifier_id) => {
    if (type === "categories") {
      setAddMenuInfo((prevState) => ({
        ...prevState,
        categories: e,
      }));
    } else if(type === "modifiers"){
      if (addMenuInfo?.modifiers.includes(modifier_id)) {
        setAddMenuInfo((prevState) => ({
          ...prevState,
          [type]: prevState[type].filter((id) => id !== modifier_id),
        }));
      } else {
        setAddMenuInfo((prevState) => ({
          ...prevState,
          [type]: [...prevState[type], modifier_id],
        }));
      }
    } else {
      const { name, value, files } = e.target;
      if (name === "is_addon") {
        if (addMenuInfo.is_addon === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "with_discount") {
        if (addMenuInfo.with_discount === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_dine_in") {
        if (addMenuInfo.is_dine_in === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_take_out") {
        if (addMenuInfo.is_take_out === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_delivery") {
        if (addMenuInfo.is_delivery === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } 

      else if (name === "suspend_sale") {
        if (addMenuInfo.suspend_sale === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_modifier") {
        if (addMenuInfo.is_modifier === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
            with_modifier: "0"
          }));
        }
      } else if (name === "with_modifier") {
        if (addMenuInfo.with_modifier === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "ref_name") {
        if (addMenuInfo.ref_name === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "is_addon") {
        if (addMenuInfo.is_addon === "1") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "ref_no") {
        if (addMenuInfo.ref_no === "ref_no") {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",
          }));
        } else {
          setAddMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
          }));
        }
      } else if (name === "file") {
        setAddMenuInfo((prevState) => ({
          ...prevState,
          [name]: files,
        }));
      } else {
        setAddMenuInfo((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };
  
  //Create API Menu
  async function createMenu() {
    setIsClicked(true);
    if (validateMenu(addMenuInfo, packageDetails, setIsError)) {
      setIsClicked(true);
      const response = await createMenuManager(
        addMenuInfo,
        computedVat,
        packageDetails
      );
      if (response.data) {
        toast.success("Successfully Created Menu!", { style: toastStyle() });
        setTimeout(() => {refreshPage()}, 500)
      } else {
        setIsClicked(false);
        toast.error(response.error.data.messages.file, { style: toastStyle() });
      }
    } else {
      setIsClicked(false);
    }
  }

  // ----------------------------------------------------------------------------------------------------------
  //EDIT or UPDATE USER
  const handleEditNew = (selectedOptions, fieldName) => {
    if (fieldName === "default_categories") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        default_categories: selectedOptions,
      }));
    }
    if (fieldName === "menu_remarks") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        menu_remarks: selectedOptions,
      }));
    }
    if (fieldName === "frequency") {
      setEditMenuInfo((prevState) => ({
        ...prevState,
        frequency: selectedOptions.value,
      }));
    }
  };

  const handleEditChange = (e, type, modifier_id) => {
    if(type === "menu_modifiers"){
      if (editMenuInfo?.menu_modifiers.includes(modifier_id)) {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [type]: prevState[type].filter((id) => id !== modifier_id),
        }));
      } else {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [type]: [...prevState[type], modifier_id],
        }));
      }
    } else {
      const { name, value, checked } = e.target;
      if (name === "is_addon") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "ref_name") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "suspend_sale") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "is_modifier") {
        if(checked){
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "1",
            with_modifier: "0"
          }));
        } else {
          setEditMenuInfo((prevState) => ({
            ...prevState,
            [name]: "0",

          }));
        }
      } else if (name === "with_modifier") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "ref_no") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "with_discount") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "is_delivery") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "is_take_out") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "is_dine_in") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      } else if (name === "is_addon") {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: checked ? "1" : "0",
        }));
      }
      else {
        setEditMenuInfo((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };

  async function updateMenu() {
    setIsClicked(true);
    
    editMenuInfo.categories = editMenuInfo.default_categories;
    if (validateMenu(editMenuInfo, packageDetails, setIsError)) {
      setIsClicked(true);
      const response = await updateMenuManager(editMenuInfo, computedVat, packageDetails);

      if (response.data) {
        toast.success("Successfully Updated Menu!", { style: toastStyle() });
        setTimeout(() => {refreshPage()}, 500)
      } else {
        toast.error("Error Updating New Menu", { style: toastStyle() });
        setIsClicked(false);
      }
    } else {
      setIsClicked(false);
    }
  }

  //onEdit
  function handleOnEdit() {
    handleCloseViewUserModal();
    handleShowEditUserModal();
  }

  // ----------------------------------------------------------------------------------------------------------
  //DELETE or REMOVE MENU
  async function handleDeleteMenu() {
    const response = await deleteMenuManager(selectedRow.id);
    if (response.data) {
      toast.success("Successfully Deleted Menu!", { style: toastStyle() });
      setTimeout(() => {refreshPage()}, 500)
    } else {
      toast.error(response.error.data.messages.error, { style: toastStyle() });
    }
  }

  useEffect(() => {
    searchMenu([]);
    fetchCategories();
  }, []);

  useEffect(() => {
    if(showAddUserModal || showEditUserModal){
      searchModifiers();
    }
  }, [showAddUserModal, showEditUserModal]);

  useEffect(() => {
    fetchVatIn();
  }, [addMenuInfo.price, addMenuInfo.is_vatable]);

  useEffect(() => {
    fetchEditVatIn();
  }, [editMenuInfo.price, editMenuInfo.is_vatable]);


  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page">
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"Menus"}
          page={"Menus"}
        />
      </div>
      <div className={`container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-3">
          <Col xs={6}>
            <label className="page-title-menu"> MENU MANAGER </label>
          </Col>
          <Col xs={4} className="mt-1 d-flex justify-content-end">
            <Input
              suffix={<SearchOutlined />}
              placeholder="Search menu"
              className="h-100"
              onKeyDown={(e) =>
                e.key === ("Enter" || "NumpadEnter") && searchMenu(searchText)
              }
              onChange={(e) => {
                if (e.target.value === "") {
                  searchMenu(e.target.value);
                }
                setSearchText(e.target.value);
              }}
            />
          </Col>
          <Col xs={2}>
            <button
              className="category-new-export-btn"
              onClick={handleShowAddUserModal}
            >
              Add
            </button>
          </Col>
        </Row>

        <div className="table-content mb-5">
          {/* TABLE */}
          <Table
            tableHeaders={[
              "CATEGORIES",
              "NAME",
              "ITEM CODE",
              "PRICE",
              "FOODPANDA PRICE",
              "GRAB PRICE",
              "ACTIONS",
            ]}
            headerSelector={[
              "category_name",
              "name",
              "item_code",
              "price",
              "foodpanda_price",
              "grab_price",
              "suspend_sale",
            ]}
            tableData={menuItems}
            ActionBtn={(row) => ActionBtn(row)}
            showLoader={showLoader}
          />
        </div>
        <div>
          <label className="powered-label pt-5 mt-5 text-center">
            Powered by MYT SofDev Solutions Inc. EPSOS 1.0.0
          </label>
        </div>
      </div>

      {/* MODALS */}
      <DeleteModal
        text="menu"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteMenu}
      />

      <AddModal
        title="MENU"
        type="user"
        show={showAddUserModal}
        loader={isClicked}
        onHide={handleCloseAddUserModal}
        onSave={createMenu}
      >
        <div className="mt-3">
          <Row className="nc-modal-custom-row">
            <Col>
              NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError isValid={isError.name} message={"Name is required"} />
            </Col>
            <Col>
              CATEGORY
              {
                addMenuInfo?.is_modifier === "0" && (
                  <span className="required">*</span>
                )
              }
              <Select
                className="text-start react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Category..."
                options={categories}
                name="categories"
                isMulti
                onChange={(e) => handleAddChange(e, "categories")}
              />
              <InputError
                isValid={isError.categories}
                message={"Menu Category is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              MENU LOCATION
              <span className="required"> * </span>
              <AntSelect
                placeholder="Select location..."
                options={[
                  { label: "happyhippos", value: "happyhippos" },
                  // { label: "Ettas", value: "ettas" },
                ]}
                name="menu_location"
                value={addMenuInfo.menu_location}
                onChange={(e) =>
                  setAddMenuInfo((prev) => ({ ...prev, menu_location: e }))
                }
                dropdownStyle={{
                  zIndex: 10000,
                  fontFamily: "var(--primary-font-medium)",
                  fontSize: "12pt",
                }}
              />
              <InputError
                isValid={isError.menu_location}
                message={"Menu Location is required"}
              />
            </Col>
            <Col>
              ITEM CODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="item_code"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError
                isValid={isError.item_code}
                message={"Item Code is required"}
              />
            </Col>
            <Col>
              DEFAULT PRINTER
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="default_printer"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError
                isValid={isError.default_printer}
                message={"Default Printer is required"}
              />
            </Col>
            <Col>
              EFFECTIVE DATE
              <span className="required"> * </span>
              <Form.Control
                type="date"
                name="effective_date"
                className="nc-modal-custom-input"
                value={addMenuInfo.effective_date}
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.effective_date}
                message={"Effective date is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              STORE PRICE
              <span className="required"> * </span>
              <Form.Control
                type="number"
                name="price"
                min={0}
                value={addMenuInfo.price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
              <InputError
                isValid={isError.price}
                message={"Price is required"}
              />
            </Col>
            <Col>
              TAKEOUT PRICE
              <Form.Control
                type="number"
                name="takeout_price"
                min={0}
                value={addMenuInfo.takeout_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
              />
            </Col>
            <Col>
              FOODPANDA PRICE
              <Form.Control
                type="number"
                name="foodpanda_price"
                min={0}
                value={addMenuInfo.foodpanda_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
            </Col>
            <Col>
              GRAB PRICE
              <Form.Control
                type="number"
                name="grab_price"
                min={0}
                value={addMenuInfo.grab_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddOnChange(e)}
                required
              />
            </Col>
          </Row>

          <Row className="nc-modal-custom-row">
            <Col>
              VAT In
              <Form.Control
                type="number"
                name="vat_in"
                min={0}
                disabled
                value={addMenuInfo.price}
                className="nc-modal-custom-input"
                required
              />
              <InputError
                isValid={isError.vat_in}
                message={"Vat In is required"}
              />
            </Col>
            <Col>
              VAT Ex
              <Form.Control
                type="number"
                name="vat_ex"
                disabled
                value={addMenuInfo.vat_ex}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              VAT COMPONENT
              <Form.Control
                type="text"
                name="vat_component"
                disabled
                value={addMenuInfo.vat_component}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              OTHER CHARGES
              <Form.Control
                type="text"
                name="other_charges"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs="4">
              AVAILABLE FOR:
              <div>
                <input
                  id="is_vatable"
                  class="checkbox-custom"
                  name="is_vatable"
                  type="checkbox"
                  onChange={(e) => {
                    // CONFUSING SIYA BUT BASICALLY IF CHECKED AND NON-VAT, FALSE ANG IS_VATABLE DIBA?
                      setAddMenuInfo((prevState) => ({
                        ...prevState,
                        is_vatable: e.target.checked?"0":"1",
                      }));
                  }}
                />
                <label for="is_vatable" class="checkbox-custom-label">
                  Non-VAT
                </label>
              </div>
              <div>
                <input
                  id="with_discount"
                  class="checkbox-custom"
                  name="with_discount"
                  type="checkbox"
                  onChange={(e) => handleAddChange(e)}
                  value="1"
                />
                <label for="with_discount" class="checkbox-custom-label">
                  WITH DISCOUNT
                </label>
              </div>
              <div>
                <input
                  id="suspend_sale"
                  class="checkbox-custom"
                  name="suspend_sale"
                  type="checkbox"
                  onChange={(e) => handleAddChange(e)}
                  value="1"
                />
                <label for="suspend_sale" class="checkbox-custom-label">
                  SUSPEND SALE
                </label>
              </div>
              <div>
                <input
                  id="is_modifier"
                  class="checkbox-custom"
                  name="is_modifier"
                  type="checkbox"
                  onChange={(e) => handleAddChange(e)}
                  value="1"
                />
                <label for="is_modifier" class="checkbox-custom-label">
                  IS MODIFIER
                </label>
              </div>
              {
                addMenuInfo?.is_modifier === "0" && (
                  <div>
                    <input
                      id="with_modifier"
                      class="checkbox-custom"
                      name="with_modifier"
                      type="checkbox"
                      disabled={addMenuInfo?.is_modifier === "1"}
                      onChange={(e) => handleAddChange(e)}
                      value="1"
                    />
                    <label for="with_modifier" class="checkbox-custom-label">
                      WITH MODIFIER
                    </label>
                  </div>
                )
              }
            </Col>
            <Col xs="8">
              {
                addMenuInfo?.with_modifier === "1" && (
                  <>
                    <Row>MODIFIERS:</Row>
                    <Row>
                      {
                        modifierItems?.map((data) => (
                          <Col xs="4">
                            <input
                              id={data?.menu_item_name}
                              class="checkbox-custom"
                              name={data?.menu_item_name}
                              type="checkbox"
                              onChange={(e) => handleAddChange(e, "modifiers", data?.menu_id)}
                            />
                            <label for={data?.menu_item_name} class="checkbox-custom-label">
                              {data?.menu_item_name.toUpperCase()}
                            </label>
                          </Col>
                        ))
                      }
                    </Row>
                  </>
                )
              }
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              <span className="required"> * </span>
              <span className="required"> required fields </span>
            </Col>
          </Row>
        </div>
      </AddModal>

      <EditModal
        title="MENU"
        type="menu"
        show={showEditUserModal}
        onHide={handleCloseEditUserModal}
        onSave={updateMenu}
        loader={isClicked}
      >
        <div className="mt-3 edit-form">
          <Row className="nc-modal-custom-row">
            <Col>
              NAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="name"
                className="nc-modal-custom-input"
                value={editMenuInfo.name}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError isValid={isError.name} message={"Name is required"} />
            </Col>
            <Col>
              CATEGORY
              {
                editMenuInfo?.is_modifier === "0" && (
                  <span className="required">*</span>
                )
              }
              <Select
                className="text-start react-select-container"
                classNamePrefix="react-select"
                placeholder="Select Category..."
                options={categories}
                name="menu_categories"
                isMulti
                value={editMenuInfo?.default_categories}
                onChange={(e) => handleEditNew(e, "default_categories")}
              />
              <InputError
                isValid={isError.default_categories}
                message={"Menu Category is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              MENU LOCATION
              <span className="required"> * </span>
              <AntSelect
                placeholder="Select location..."
                options={[
                  { label: "happyhippos", value: "happyhippos" },
                  // { label: "Ettas", value: "ettas" },
                ]}
                name="menu_location"
                value={editMenuInfo.menu_location}
                onChange={(e) =>
                  setEditMenuInfo((prev) => ({ ...prev, menu_location: e }))
                }
                dropdownStyle={{
                  zIndex: 10000,
                  fontFamily: "var(--primary-font-medium)",
                  fontSize: "12pt",
                }}
              />
              <InputError
                isValid={isError.menu_location}
                message={"Menu Location is required"}
              />
            </Col>
            <Col>
              ITEM CODE
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="item_code"
                className="nc-modal-custom-input"
                value={editMenuInfo.item_code}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.item_code}
                message={"Item Code is required"}
              />
            </Col>
            <Col>
              DEFAULT PRINTER
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="default_printer"
                className="nc-modal-custom-input"
                value={editMenuInfo.default_printer}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.default_printer}
                message={"Default Printer is required"}
              />
            </Col>
            <Col>
              EFFECTIVE DATE
              <span className="required"> * </span>
              <Form.Control
                type="date"
                name="effective_date"
                value={editMenuInfo.effective_date}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.effective_date}
                message={"Effective date is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              STORE PRICE
              <span className="required"> * </span>
              <Form.Control
                type="number"
                name="price"
                min={0}
                value={editMenuInfo.price}
                className="nc-modal-custom-input"
                onChange={(e) => {
                  setEditMenuInfo((prev) => ({...prev,
                    price: e.target.value,
                    vat_in: e.target.value,
                  }))
                }}
                required
              />
              <InputError
                isValid={isError.price}
                message={"Price is required"}
              />
            </Col>
            <Col>
              TAKEOUT PRICE
              <Form.Control
                type="number"
                name="takeout_price"
                min={0}
                value={editMenuInfo.takeout_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
              />
            </Col>
            <Col>
              FOOD PANDA PRICE
              <Form.Control
                type="number"
                name="foodpanda_price"
                min={0}
                value={editMenuInfo.foodpanda_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
            <Col>
              GRAB PRICE
              <Form.Control
                type="number"
                name="grab_price"
                min={0}
                value={editMenuInfo.grab_price}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
            </Col>
          </Row>

          <Row className="nc-modal-custom-row">
            <Col>
              VAT In
              <span className="required"> * </span>
              <Form.Control
                type="number"
                name="vat_in"
                min={0}
                disabled
                className="nc-modal-custom-input"
                value={editMenuInfo.vat_in}
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isError.vat_in}
                message={"Vat In is required"}
              />
            </Col>
            <Col>
              VAT Ex
              <Form.Control
                type="number"
                name="vat_ex"
                disabled
                value={editMenuInfo.vat_ex}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              VAT COMPONENT
              <Form.Control
                type="text"
                name="vat_component"
                disabled
                value={editMenuInfo.vat_component}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              OTHER CHARGES
              <Form.Control
                type="text"
                name="other_charges"
                className="nc-modal-custom-input"
                value={editMenuInfo.other_charges}
                onChange={(e) => handleEditChange(e)}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs="4">
              AVAILABLE FOR:
              <div>
                <input
                  id="is_vatable"
                  class="checkbox-custom"
                  name="is_vatable"
                  type="checkbox"
                  onChange={(e) => setEditMenuInfo((prevState) => ({
                    ...prevState,
                    is_vatable: e.target.checked?"0":"1",
                  }))}
                  checked={
                    editMenuInfo.is_vatable === "1" ? false : true
                  }
                />
                <label for="is_vatable" class="checkbox-custom-label">
                  Non-VAT
                </label>
              </div>
              <div>
                <input
                  id="with_discount"
                  class="checkbox-custom"
                  name="with_discount"
                  type="checkbox"
                  onChange={(e) => handleEditChange(e)}
                  checked={editMenuInfo.with_discount === "0" ? false : true}
                />
                <label for="with_discount" class="checkbox-custom-label">
                  WITH DISCOUNT
                </label>
              </div>
              <div>
                <input
                  id="suspend_sale"
                  class="checkbox-custom"
                  name="suspend_sale"
                  type="checkbox"
                  onChange={(e) => handleEditChange(e)}
                  checked={editMenuInfo.suspend_sale === "0" ? false : true}
                />
                <label for="suspend_sale" class="checkbox-custom-label">
                  SUSPEND SALE
                </label>
              </div>
              <div>
                <input
                  id="is_modifier"
                  class="checkbox-custom"
                  name="is_modifier"
                  type="checkbox"
                  onChange={(e) => handleEditChange(e)}
                  checked={editMenuInfo.is_modifier === "0" ? false : true}
                />
                <label for="is_modifier" class="checkbox-custom-label">
                  IS MODIFIER
                </label>
              </div>
              {
                editMenuInfo?.is_modifier === "0" && (
                  <div>
                    <input
                      id="with_modifier"
                      class="checkbox-custom"
                      name="with_modifier"
                      type="checkbox"
                      onChange={(e) => handleEditChange(e)}
                      checked={editMenuInfo.with_modifier === "0" ? false : true}
                    />
                    <label for="with_modifier" class="checkbox-custom-label">
                      WITH MODIFIER
                    </label>
                  </div>
                )
              }
            </Col>
            <Col xs="8">
              {
                editMenuInfo?.with_modifier === "1" && (
                  <>
                    <Row>MODIFIERS:</Row>
                    <Row>
                      {
                        modifierItems?.map((data) => (
                          <Col xs="3">
                            <input
                              id={data?.menu_item_name}
                              class="checkbox-custom"
                              name={data?.menu_item_name}
                              type="checkbox"
                              onChange={(e) => handleEditChange(e, "menu_modifiers", data.menu_id)}
                              checked={editMenuInfo?.menu_modifiers.includes(data.menu_id)}
                            />
                            <label for={data?.menu_item_name} class="checkbox-custom-label">
                              {data?.menu_item_name.toUpperCase()}
                            </label>
                          </Col>
                        ))
                      }
                    </Row>
                  </>
                )
              }
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              <span className="required"> * </span>
              <span className="required"> required fields </span>
            </Col>
          </Row>
        </div>
      </EditModal>

      <ViewModal
        withButtons
        show={showViewUserModal}
        onHide={handleCloseViewUserModal}
        onEdit={handleOnEdit}
      >
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-user-details">
              MENU DETAILS
            </span>
            <div className="mt-3 container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col className="text-start">
                  <span>NAME</span>
                  <br />
                  {selectedRow.name}
                </Col>
                <Col className="text-start">
                  <span>ITEM CODE</span>
                  <br />
                  {selectedRow.item_code}
                </Col>
                <Col className="text-start">
                  <span>CATEGORY</span>
                  <br />
                  {selectedRow.category_name}
                </Col>
                <Col className="text-start">
                  <span>MENU LOCATION</span>
                  <br />
                  {selectedRow.menu_location?.toUpperCase()}
                </Col>
              </Row>
              <Row className="nc-modal-custom-row-view mt-4">
                <Col className="text-start">
                  <span>PRICE</span>
                  <br />
                  {formatAmount(selectedRow.price)}
                </Col>
                <Col className="text-start">
                  <span>TAKEOUT PRICE</span>
                  <br />
                  {formatAmount(selectedRow.takeout_price)}
                </Col>
                <Col className="text-start">
                  <span>FOODPANDA PRICE</span>
                  <br />
                  {formatAmount(selectedRow.foodpanda_price)}
                </Col>
                <Col className="text-start">
                  <span>GRAB PRICE</span>
                  <br />
                  {formatAmount(selectedRow.grab_price)}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </ViewModal>
    </div>
  );
}
